import { render, staticRenderFns } from "./drawOptionPreview.vue?vue&type=template&id=1408ee30&scoped=true&lang=pug&"
import script from "./drawOptionPreview.vue?vue&type=script&lang=js&"
export * from "./drawOptionPreview.vue?vue&type=script&lang=js&"
import style0 from "./drawOptionPreview.vue?vue&type=style&index=0&id=1408ee30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408ee30",
  null
  
)

export default component.exports